export default __webpack_public_path__ + "60f4cc9519101b0c1a7bca835c1d7eb0.png";